import { Box, styled } from '@mui/material'

export const StyledBox = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 48px;
`
